
import { defineComponent, PropType } from "vue";
import ActionInterface from "../Tabela/Interface/ActionInterface";

export default defineComponent({
  name: "BotaoAcoes",
  props: {
    acoes: {
      type: Array as PropType<ActionInterface[]>,
      required: true,
    },
    id: {
      type: [Number, String],
      required: true,
    },
  },
});
